<template>
  <Widget />
</template>

<script>
import Widget from './components/Widget.vue'

export default {
  name: 'App',
  components: {
    Widget
  }
}
</script>

<style lang="scss">
@import "./scss/_variables.scss";
@import "./scss/responsive.scss";

#annuaire-public {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  font-size: 12px;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  box-sizing: border-box;

  p,
  li {
    color: rgba(0, 0, 0, 0.87);
  }

  input {
    padding: 0.7em;
  }

  button:hover {
    cursor: pointer;
  }

  a {
    text-decoration: none;
    color: $base-color;
  }
}
</style>
